import { render } from "./DataLainnya.vue?vue&type=template&id=2aafd1e6"
import script from "./DataLainnya.vue?vue&type=script&lang=js"
export * from "./DataLainnya.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__